import { templateJitUrl } from '@angular/compiler';
import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService, SessionService } from '../../../services';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
    selector: 'sn-usc-timeslot-picker',
    templateUrl: './usc-timeslot-picker.component.html',
    styleUrls: ['./usc-timeslot-picker.component.css']
})
export class UscTimeslotPickerComponent implements OnInit {
@Input() schedule_date:Date;
@Input() view_ID:string;
// @Input() scheduling_mode:string;

    timeslots:any[] = [];
    isLoading:boolean = true;
    isFailure:boolean = false;
    hasTimeslots:boolean = false;
    showOverride:boolean = false;
    showOverrideToggle:boolean = false;
    failure_message:string = "";

    constructor(
        public ngbModal: NgbModal,
        public activeModal: NgbActiveModal,
        public uscStoreService: UscStoreService,
        public apiService: ApiService,
        public sessionService: SessionService,
    ) { }

    ngOnInit() {
        this.getAvailableTimeSlots();
    }

    getAvailableTimeSlots() {
        this.isLoading = true;
        this.hasTimeslots = false;
        var year = this.schedule_date.getUTCFullYear();
        var month = this.schedule_date.getUTCMonth() + 1;
        var date = this.schedule_date.getUTCDate();
        var data = { date: `${year}-${month}-${date}`, deal_ID: `${this.view_ID}`, show_override: this.showOverride ? "Yes" : "No" };
        var action_view = this.uscStoreService.isQueuingModuleAccessEnabled() ? 'salesnow_get_appt_timeslots' : 'qtrac_get_appt_timeslots';
        this.apiService.processMeetingAction(action_view, data, "raw").subscribe(
            response => {
                this.isLoading = false; 
                this.isFailure = false;
                if (response.status == "Failure") {
                    this.failure_message = response.message;
                    this.isFailure = true;
                } else {
                    this.showOverrideToggle = response.show_override_toggle;
                    console.log('qtrac_get_appt_timeslots succeed', response.timeslots);
                    this.hasTimeslots = response.timeslots.length > 0;
                    this.timeslots = response.timeslots;
                }
            }, 
            err => { 
                this.isLoading = false;
                console.log('qtrac_get_appt_timeslots failed', err);
                this.sessionService.log("unable to get timeslots");
            }
        )          
    }

    onConfirm(slot) {
        var message = "";
        if (this.isConcurrent(slot)) message = "A Peer has an appointment at this time.  Do you wish to proceed?";
        if (this.isOffHours(slot)) message = "This is an off hours appointment time.  Do you wish to proceed?";
        if (this.isHoliday(slot)) message = "This is a holiday appointment time.  Do you wish to proceed?";
    
        const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
        modalRef.componentInstance.dlgType = this.uscStoreService.dialog_type_yes_no_prompt;
        modalRef.componentInstance.msg_config = { msg: message, };
        modalRef.result.then((result) => {
            this.activeModal.close(slot);
        }, (reason) => {
        });
    }

    onSubmit(timeslot) {
        this.activeModal.close(timeslot);
    }

    onCancel() {
        this.activeModal.dismiss();
    }

    isAvailable(slot) { return slot.type == 'Available'; }
    isOverride(slot) { return this.isConcurrent(slot) || this.isOffHours(slot) || this.isHoliday(slot); }
    isConcurrent(slot) { return slot.type == 'Concurrent'; }
    isOffHours(slot) { return slot.type == 'OffHours'; }
    isHoliday(slot) { return slot.type == 'VacationDay' || slot.type == 'Holiday'; }
    isConflict(slot) { return slot.type == 'Conflict'; }
    getLabel(slot) { return slot.label; }
    getScheduleDate() { return this.schedule_date.toUTCString().substring(0, 16); }

    includeOverride() { 
        this.showOverride = true; 
        this.getAvailableTimeSlots();
    }
    excludeOverride() { 
        this.showOverride = false; 
        this.getAvailableTimeSlots();
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-timeslot-picker/usc-timeslot-picker.component.ts